import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectBusinessesQueryItems } from '../../../../../redux/businesses/selector';
import PageLoader from '../../../../../components/PageLoader';
import { deepCopy } from '../../../../../common/services/common.service';
import OnBoardingDetails from '../components/onboarding/onboarding.component';
import { business } from '../../../../../redux/businesses/action';

let currentChange: any = {}
const Business= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectBusinessesQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [selectedBusiness, setSelectedBusiness] = useState<any>({
 
  OnBoardConfigurations:{}
});

const [
  onBoardDetails,
  setOnBoardDetails
] = useState<any>({
      OrganizationDetails:{},
      RegisteredAddress:[],
      FounderDetails:{},
      OtherDetails:{},
      GSTDetails:[],
      CINDetails:{},
})
const [
  authorizedSignatory,
  setAuthorizedSignatory
] = useState<any>([])

const [
  gstInfo,
  setGstInfo
] = useState<any>([])
const handleInnerFormChange: any = (event: any, field: string) => {
  setSelectedBusiness({ ...selectedBusiness, [field]: event });
}

const [
  registeredAddress,
  setRegisteredAddress
] = useState<any>([])

  const fetchSubscriptionsById= ()=>{
    dispatch(business.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business/query`,entity:'subscriptions',jsonData:{
          
        "Records": [
          {
            "Context": {
              "Subscription": "ONE",
                                    "Domain": "ONE",
                                    "SubDomains": [],
                                    "Network": "Venture",
                                    "Application": "Venture",
                                    "Channel": "CSP"
            },
            "Message": {
              "Id": 0
            }
          }
        ]
}})).then(()=>{
  setIsQuery(true)
})
  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setOnBoardDetails({ ...onBoardDetails, [field]: event })
  }

  const handleFormChange = ({ value, field, data }: any) => {
    const fields = field.split('.');
    setOnBoardDetails((prevState: any) => ({
      ...prevState,
      [fields[0]]: {
        ...prevState[fields[0]], 
        [fields[1]]: value 
      }
    }));
  };
 
  useEffect(
    () => {
        fetchSubscriptionsById()
        const localSelectedKeywords = addNewKeywordsRow({ selectedKeywordsArg: authorizedSignatory });
        setAuthorizedSignatory(localSelectedKeywords)
        const localSelectedGST = addNewGSTRow({ selectedGSTArg: gstInfo });
        setGstInfo(localSelectedGST)
        const localSelectedAddress = addNewAddressRow({ selectedAddressArg: registeredAddress });
        setRegisteredAddress(localSelectedAddress)
        setIsLoading(false)
  },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedBusiness(queryItems?.result?.items) 
        const onBoardDetailInfo: any ={
          OrganizationDetails:{
            OrganizationName: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.OrganizationName || '',
            LegalEntityName: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.LegalEntityName || '',
            WebsiteURL: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.WebsiteURL || '',
            YearOfIncorporation: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.YearOfIncorporation || '',
            NumberOfEmployees: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.NumberOfEmployees || 0,
            TurnoverOfOrganization: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.TurnOverOfOrganization || 0,
            NatureOfOrganization: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.NatureOfOrganization || '',
            SectorOfOrganization: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.SectorOfOrganization || '',
            StatusOfProductApplication: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.StatusOfProduct_Application || 0,
            IsAllStatesCities: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.IsAllStates_Cities || false,
            AreaOfOperationsStates: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.AreaOfOperations_States || [],
            AreaOfOperationsCities: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.AreaOfOperations_Cities || [],
            DomainOfProductOrServices: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OrganizationDetails?.DomainOfProductOrServices || []
              }, 
            FounderDetails:{
              FirstNameOfFounder_CEO: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.FounderDetails?.FirstNameOfFounder_CEO ||'',
              LastNameOfFounder_CEO:queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.FounderDetails?.LastNameOfFounder_CEO||'',
              EmailOfFounder_CEO: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.FounderDetails?.EmailOfFounder_CEO||'',
            },
            OtherDetails:{
              PAN: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OtherDetails?.PAN||'',
              NameAsPerPAN: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.OtherDetails?.NameAsPerPAN||'',
            },  
            CINDetails:{
              CIN_Id:queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.CINDetails?.CIN_Id||'',
              CIN_Attachments:queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.CINDetails?.CIN_Attachments||[],
              UdhyamNumber:queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.CINDetails?.UdhyamNumber||'',
              UdhyamRegisteredCertificate:queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.CINDetails?.UdhyamRegisteredCertificate||[],
              DUNSNumber:queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.CINDetails?.DUNSNumber||'',
            },
            SellerNP_MSNModel:{
              Top3CitiesWithMaximumSeller: queryItems?.result?.items?.OnBoardConfigurations?.RoleSpecificInformation?.SellerNP_MSNModel?.Top3CitiesWithMaximumSeller||[],
              ActiveRegisteredSellers: queryItems?.result?.items?.OnBoardConfigurations?.RoleSpecificInformation?.SellerNP_MSNModel?.ActiveRegisteredSellers||'',
              TopCategoryOfProductService: queryItems?.result?.items?.OnBoardConfigurations?.RoleSpecificInformation?.SellerNP_MSNModel?.TopCategoryOfProductService||[],
            },
            SellerNP_ISNModel:{
              NoOfPOSOrStore: queryItems?.result?.items?.OnBoardConfigurations?.RoleSpecificInformation?.SellerNP_ISNModel?.NoOfPOSOrStore||[],
              TopCategoryOfProductService: queryItems?.result?.items?.OnBoardConfigurations?.RoleSpecificInformation?.SellerNP_ISNModel?.TopCategoryOfProductService||[],
            }
          }  
          setOnBoardDetails(onBoardDetailInfo)
        }
       
        const localSelectedKeywords = addNewKeywordsRow({ selectedKeywordsArg: queryItems?.result?.items?.OnBoardConfigurations?.AuthorisedSignatory });
        setAuthorizedSignatory(localSelectedKeywords)
        const localSelectedGST = addNewGSTRow({ selectedGSTArg: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.GSTDetails});
        setGstInfo(localSelectedGST)
        const localSelectedAddress = addNewAddressRow({ selectedAddressArg: queryItems?.result?.items?.OnBoardConfigurations?.BasicInformation?.RegisteredAddress});
        setRegisteredAddress(localSelectedAddress)
      
    },
    [isQuery]
  )

  const addNewKeywordsRow = ({ selectedKeywordsArg }: any) => {
    const localSelectedKeywords = deepCopy(selectedKeywordsArg||[])
    const newsKeywords = {
      NameOfAuthorisedSignatory: '',
      EmailAddress: '',
      MobileNumber: '',
      Designation: '',
      Attachments:[],
      AadharNumber:''
    }
    if (localSelectedKeywords.length === 0 ||
      localSelectedKeywords[localSelectedKeywords?.length - 1]?.NameOfAuthorisedSignatory !== ''
    ) {
      localSelectedKeywords?.push(newsKeywords)
    }

    return localSelectedKeywords
  }

  const addNewGSTRow = ({ selectedGSTArg }: any) => {
    const localSelectedGST = deepCopy(selectedGSTArg||[])
    const newsKeywords = {
      GSTIN_1: '',
      NameAsPerGSTIN: '',
      VerifiedGSTINAddress: ''
    }
    if (localSelectedGST.length === 0 ||
      localSelectedGST[localSelectedGST?.length - 1]?.GSTIN_1 !== ''
    ) {
      localSelectedGST?.push(newsKeywords)
    }

    return localSelectedGST
  }


  const addNewAddressRow = ({ selectedAddressArg }: any) => {
    const localSelectedAddress = deepCopy(selectedAddressArg||[])
    const newsKeywords = {
      Building_Street_Area: '',
      Locality_Town: '',
      City_District: '',
      Country: '',
      State:'',
      Pincode: ''
    }
    if (localSelectedAddress.length === 0 ||
      localSelectedAddress[localSelectedAddress?.length - 1]?.Building_Street_Area !== ''
    ) {
      localSelectedAddress?.push(newsKeywords)
    }

    return localSelectedAddress
  }

  const handleFormAuthorizedSignatoryItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(authorizedSignatory);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setAuthorizedSignatory(items);
  }

  const handleFormGSTItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(gstInfo);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setGstInfo(items);
  }

  const handleFormAddressItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(registeredAddress);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setRegisteredAddress(items);
  }

  const setCombinationKeywordInfo = async () => {
    let localSelectedKeyword = deepCopy(authorizedSignatory||[])
    localSelectedKeyword.splice(
      currentChange.idx,
      1,
      { ...localSelectedKeyword[currentChange.idx] }
    );
    localSelectedKeyword = addNewKeywordsRow({ selectedKeywordsArg: localSelectedKeyword });
    currentChange.field = 'NameOfAuthorisedSignatoryD1'
    setAuthorizedSignatory(localSelectedKeyword)
  }
  useEffect(
    () => {
      if (currentChange.field === 'NameOfAuthorisedSignatory') {
        setCombinationKeywordInfo()
      }
    },
    [authorizedSignatory]
  )

  const setCombinationGSTInfo = async () => {
    let localSelectedGST = deepCopy(gstInfo)
    localSelectedGST.splice(
      currentChange.idx,
      1,
      { ...localSelectedGST[currentChange.idx] }
    );
    localSelectedGST = addNewGSTRow({ selectedGSTArg: localSelectedGST });
    currentChange.field = 'GSTIN_1D1'
    setGstInfo(localSelectedGST)
  }
  useEffect(
    () => {
      if (currentChange.field === 'GSTIN_1') {
        setCombinationGSTInfo()
      }
    },
    [gstInfo]
  )

  const setCombinationAddressInfo = async () => {
    let localSelectedAddress = deepCopy(registeredAddress)
    localSelectedAddress.splice(
      currentChange.idx,
      1,
      { ...localSelectedAddress[currentChange.idx] }
    );
    localSelectedAddress = addNewAddressRow({ selectedAddressArg: localSelectedAddress });
    currentChange.field = 'Building_Street_AreaD1'
    setRegisteredAddress(localSelectedAddress)
  }
  useEffect(
    () => {
      if (currentChange.field === 'Building_Street_Area') {
        setCombinationAddressInfo()
      }
    },
    [registeredAddress]
  )
  const handleFormSubmit = async (event: any) => {
    
    event.preventDefault();
    authorizedSignatory.splice(
      authorizedSignatory.length - 1,
      1
    )
    gstInfo.splice(
      gstInfo.length - 1,
      1
    )
    registeredAddress.splice(
      registeredAddress.length - 1,
      1
    )
  
    const onBoardConfigurations = {
      BasicInformation: {
        OrganizationDetails: {
          OrganizationName: onBoardDetails?.OrganizationDetails?.OrganizationName || '',
          LegalEntityName: onBoardDetails?.OrganizationDetails?.LegalEntityName || '',
          WebsiteURL: onBoardDetails?.OrganizationDetails?.WebsiteURL || '',
          YearOfIncorporation: onBoardDetails?.OrganizationDetails?.YearOfIncorporation || '',
          NumberOfEmployees: onBoardDetails?.OrganizationDetails?.NumberOfEmployees || 0,
          TurnOverOfOrganization: onBoardDetails?.OrganizationDetails?.TurnOverOfOrganization || 0,
          NatureOfOrganization: onBoardDetails?.OrganizationDetails?.NatureOfOrganization || '',
          SectorOfOrganization: onBoardDetails?.OrganizationDetails?.SectorOfOrganization || '',
          StatusOfProductApplication: onBoardDetails?.OrganizationDetails?.StatusOfProduct_Application || 0,
          IsAllStatesCities: onBoardDetails?.OrganizationDetails?.IsAllStates_Cities || false,
          AreaOfOperationsStates: onBoardDetails?.OrganizationDetails?.AreaOfOperations_States || [],
          AreaOfOperationsCities: onBoardDetails?.OrganizationDetails?.AreaOfOperations_Cities || [],
          DomainOfProductOrServices: onBoardDetails?.OrganizationDetails?.DomainOfProductOrServices || []
        },
        RegisteredAddress: registeredAddress,
        FounderDetails: {
          FirstNameOfFounder_CEO: onBoardDetails?.FounderDetails?.FirstNameOfFounder_CEO || '',
          LastNameOfFounder_CEO: onBoardDetails?.FounderDetails?.LastNameOfFounder_CEO || '',
          EmailOfFounder_CEO: onBoardDetails?.FounderDetails?.EmailOfFounder_CEO || '',
        },
        OtherDetails: {
          PAN: onBoardDetails?.OtherDetails?.PAN || '',
          NameAsPerPAN: onBoardDetails?.OtherDetails?.NameAsPerPAN || '',
        },
        GSTDetails: gstInfo,
        CINDetails: {
          CIN_Id: onBoardDetails?.CINDetails?.CIN_Id || '',
          CIN_Attachments: onBoardDetails?.CINDetails?.CIN_Attachments || [],
          UdhyamNumber: onBoardDetails?.CINDetails?.UdhyamNumber || '',
          UdhyamRegisteredCertificate: onBoardDetails?.CINDetails?.UdhyamRegisteredCertificate || [],
          DUNSNumber: onBoardDetails?.CINDetails?.DUNSNumber || '',
        }
      },
      AuthorisedSignatory: authorizedSignatory,
      RoleSpecificInformation: {
        SellerNP_MSNModel: {
          Top3CitiesWithMaximumSeller: onBoardDetails?.SellerNP_MSNModel?.Top3CitiesWithMaximumSeller || [],
          ActiveRegisteredSellers: onBoardDetails?.SellerNP_MSNModel?.ActiveRegisteredSellers || '',
          TopCategoryOfProductService: onBoardDetails?.SellerNP_MSNModel?.TopCategoryOfProductService || [],
        },
        SellerNP_ISNModel: {
          NoOfPOSOrStore: onBoardDetails?.SellerNP_ISNModel?.NoOfPOSOrStore || [],
          TopCategoryOfProductService: onBoardDetails?.SellerNP_ISNModel?.TopCategoryOfProductService || [],
        }
      }
    };
    
    const subscriptionData = {
      ...selectedBusiness,
      OnBoardConfigurations: onBoardConfigurations
    };
    
      await dispatch(business.resetAction({ actionType: 'update' }))
      await dispatch(business.update({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business`,
        entity: 'business',
        jsonData: {
          Records: [{
        
            "Context": {},
            "Message": subscriptionData
         }]
        }
      })).then(() => {
        back();
      });
    
  };
  const back=()=>{
    navigate('/venture/platform-management/businesses')
  } 
    return (
    <>
      {isLoading ? <PageLoader /> : 
          <OnBoardingDetails 
        handleInnerbasicFormChange={handleInnerbasicFormChange}
           selectedBusiness={selectedBusiness}
           back={back}
           id={parmas?.id}
           handleFormSubmit={handleFormSubmit}
          handleFormChange={handleFormChange}
          handleFormAuthorizedSignatoryItemChange={handleFormAuthorizedSignatoryItemChange}
          authorizedSignatory={authorizedSignatory}
          gstInfo={gstInfo}
          registeredAddress={registeredAddress}
          handleFormAddressItemChange={handleFormAddressItemChange}
          handleFormGSTItemChange={handleFormGSTItemChange}
          onBoardDetails={onBoardDetails}
          handleInnerFormChange={handleInnerFormChange}
          />  
    }
          </>
    )
    
    }
   
    export default Business;
